import React, { useEffect, useState, useRef } from "react";
import { MessageCirclePlus, Pause, Play } from "lucide-react";
import useLocalization from "../../../../hooks/useLocalization";
import { useAppContext } from "../../../../context/AppContext";
import ReactMarkdown from 'react-markdown';
import { useDispatch } from "react-redux";
import {
    clearInputValue,
    setInputDisabled,
    setIsNewChatClicked,
    setMicButtonDisabled,
    setSendButtonDisabled,
} from "../../../../store/features/ui/uiSlice";
import {
    deleteDataForTextLockFlow,
    deleteDataForVoiceLockFlow,
    setIsHideUserInputFields,
    setIsSuggestedQuestionsVisible,
    setSelectedChatId,
    setSelectedSocketLanguageData,
} from "../../../../store/features/message/textContentSlice";

function GrievanceNotRelatedToCentral({ isNotRelated, message }) {
    const [timer, setTimer] = useState(59);
    const [isPaused, setIsPaused] = useState(false);
    const timerRef = useRef(null);

    const { t } = useLocalization();
    const { setInitialLanguage, sharedApiService, setIsNewChat, setSelectedLanguageData } = useAppContext();
    const dispatch = useDispatch();

    const handleNewChat = () => {
        // setInitialLanguage();
        setSelectedLanguageData({ code: "en", label: "English" });
        dispatch(setSelectedChatId(null));
        setIsNewChat(true);
        sharedApiService.cancelAllRequests();
        dispatch(clearInputValue());
        dispatch(setSelectedSocketLanguageData(null));
        dispatch(deleteDataForVoiceLockFlow());
        dispatch(deleteDataForTextLockFlow());
        dispatch(setIsHideUserInputFields(false));
        dispatch(setIsSuggestedQuestionsVisible(true));
        dispatch(setInputDisabled(false));
        dispatch(setSendButtonDisabled(false));
        dispatch(setMicButtonDisabled(false));
        dispatch(setIsNewChatClicked(true));
    };

    useEffect(() => {
        if (!isNotRelated || isPaused) return;

        timerRef.current = setInterval(() => {
            setTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timerRef.current);
    }, [isNotRelated, isPaused]);

    useEffect(() => {
        if (timer <= 0 && isNotRelated) {
            handleNewChat();
        }
    }, [timer, isNotRelated]);

    const togglePause = () => setIsPaused(!isPaused);
    const formatText = (txt) =>
        txt
          .trim()
          // Add a space only after closing italic/bold markers
          .replace(/(?<=[^\s*])(\*{1,2})(?=[A-Za-z0-9])/g, '$1 ')
          .replace(/(\d+\.\s)/g, '\n$1');

    if (!isNotRelated) return null;

    return (
        <div className="w-full mt-4 animate-fadeIn">
            <div
                className="
                    p-6 rounded-3xl border border-purple-100
                    bg-gradient-to-br from-purple-50 to-purple-100/50
                    shadow-sm hover:shadow-md
                    backdrop-blur-xl
                    transition-all duration-300
                "
            >
                {/* <p className="text-purple-800 text-[15px] leading-relaxed">
                    {message}
                </p> */}

                <div className="space-y-2">
                    {/* <p className="text-purple-800 text-[15px] leading-relaxed">
                        {message}
                    </p> */}
                    <div className="select-text selection:bg-blue-500 selection:text-white">
                        <ReactMarkdown>{formatText(message)}</ReactMarkdown>
                    </div>

                    <a
                        href="https://pgportal.gov.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="
            inline-block
            mt-1
            text-blue-700 font-semibold text-sm
            underline underline-offset-4
            animate-fadeInSlow
            transition-all duration-300
            hover:text-blue-900
            hover:scale-[1.05]
            hover:drop-shadow-[0_0_8px_rgba(59,130,246,0.6)]
        "
                    >
                        https://pgportal.gov.in/
                    </a>
                </div>

                <div className="mt-4 flex items-center gap-3">
                    <span className="text-sm text-purple-700">
                        {t("newChat")}
                    </span>

                    <span
                        className="
                            px-3 py-1 rounded-full bg-purple-600 text-white
                            text-sm font-semibold shadow-sm
                        "
                    >
                        {timer}s
                    </span>

                    <button
                        onClick={togglePause}
                        className="
                            p-1.5 rounded-full bg-purple-200
                            text-purple-700 hover:bg-purple-300
                            shadow transition-all active:scale-95
                        "
                    >
                        {isPaused ? <Play size={16} /> : <Pause size={16} />}
                    </button>
                </div>

                <button
                    onClick={handleNewChat}
                    className="
                        mt-5 w-full flex items-center justify-center gap-2
                        bg-purple-600 hover:bg-purple-700
                        text-white font-semibold py-3
                        rounded-2xl shadow-md hover:shadow-lg
                        transition-all active:scale-95
                    "
                >
                    <MessageCirclePlus size={20} />
                    {t("newChat")}
                </button>
            </div>
        </div>
    );
}

export default GrievanceNotRelatedToCentral;
